export const promotionProductTranslationKey = 'cng-promotions-product'
